// dataLayer pushes for GTM (public/index.html loads the container by
// hostname). Never put names, emails, phone numbers or addresses in a push.

export function track(payload) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(payload);
}

// items_saved { items_count, photos_count, added_from }
export function trackItemsSaved(order, addedFrom) {
  const items = (order && order.items) || [];
  track({
    event: "items_saved",
    items_count: items.reduce((sum, i) => sum + (Number(i.qty) || 0), 0),
    photos_count: ((order && order.photos) || []).length,
    added_from: addedFrom,
  });
}
